import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export const navigationButton = css`
  position: absolute;
  top: 50%;
  margin-top: -22px;
  width: 44px;
  height: 44px;
  background-color: var(--neutral-white-base);
  border: none;
  border-radius: 50%;
  padding: 10px;
`;

export const prevNavigationButton = css`
  left: ${spacing.md}px;
`;

export const nextNavigationButton = css`
  right: ${spacing.md}px;
`;
